import type { Appointment } from '@/mocks/appointments';
import DailyCalendar from './DailyCalendar';
import WeeklyCalendar from './WeeklyCalendar';
import MonthlyCalendar from './MonthlyCalendar';

export type CalendarPeriod = 'daily' | 'weekly' | 'monthly';

interface CalendarViewProps {
  period: CalendarPeriod;
  currentDate: string; // YYYY-MM-DD anchor date
  appointments: Appointment[];
  onSlotClick: (date: string, time?: string, staff?: string) => void;
  onAppointmentClick: (appt: Appointment) => void;
  onAppointmentUpdate?: (appt: Appointment) => void;
}

function getMondayOfWeek(dateStr: string): string {
  const d = new Date(dateStr + 'T00:00:00');
  const day = d.getDay(); // 0=Sun, 1=Mon...
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  return d.toISOString().split('T')[0];
}

export default function CalendarView({ period, currentDate, appointments, onSlotClick, onAppointmentClick, onAppointmentUpdate }: CalendarViewProps) {
  if (period === 'daily') {
    return (
      <DailyCalendar
        date={currentDate}
        appointments={appointments}
        onSlotClick={onSlotClick}
        onAppointmentClick={onAppointmentClick}
        onAppointmentUpdate={onAppointmentUpdate}
      />
    );
  }

  if (period === 'weekly') {
    return (
      <WeeklyCalendar
        weekStart={getMondayOfWeek(currentDate)}
        appointments={appointments}
        onSlotClick={onSlotClick}
        onAppointmentClick={onAppointmentClick}
        onAppointmentUpdate={onAppointmentUpdate}
      />
    );
  }

  const d = new Date(currentDate + 'T00:00:00');
  return (
    <MonthlyCalendar
      year={d.getFullYear()}
      month={d.getMonth()}
      appointments={appointments}
      onDayClick={(date) => onSlotClick(date)}
      onAppointmentClick={onAppointmentClick}
      onAppointmentUpdate={onAppointmentUpdate}
    />
  );
}